// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/asset/css/bf.css
// module id = 647
// module chunks = 0